import { AUD_SMART_HELPER_OFF, NEWBUILDING_KPN_CHAT } from 'node/services/fetchExperiments/getExperiments';
import { CPD_TRAP_TEXT_CHANGES_EXPERIMENT } from 'shared/selectors/abExperiments/selectIsCpdTrapTextExperiment';

export const EXPERT_OPINION = 'aud_desktop_bx495_expert_opinion_gpt_newb';
export const NEWBUILDING_BOOKING_AUTH_EXPERIMENT = 'newbuilding_booking_authorization_desktop_v2';

export const EXPERIMENTS: string[] = [
  EXPERT_OPINION,
  NEWBUILDING_KPN_CHAT,
  NEWBUILDING_BOOKING_AUTH_EXPERIMENT,
  CPD_TRAP_TEXT_CHANGES_EXPERIMENT,
  AUD_SMART_HELPER_OFF,
];
